export const primarycolor='#9B116F'
